import http from "../http-common";

class SalonService {
    async sendLoginOTP(data) {
        return http.post(`/auth/generate-otp`, data);
    }

    async customerLogin(data) {
        return http.post(`/auth/web-login`, data);
    }

    async getSalonDataById(salonUuid, date) {
        return http.get(`/salon/${salonUuid}`, { params: { bookingDate: date } });
    }

    async getSalonImages(salonUuid) {
        return http.get(`/salon/${salonUuid}/images`);
    }

    async getSalonServices(salonUuid) {
        return http.get(`/salon/${salonUuid}/services`);
    }

    async fetchSalonEmps(salonUuid, date, apntStart) {
        return http.get(`/salon/${salonUuid}/employees`, {
            params: { bookingDate: date, apntStart },
        });
    }

    async bookAppointment(appointmentData) {
        return http.post(`/appointments/book-appointment`, appointmentData);
    }

    async getSalonDetails(token) {
        return http.get(`/auth/salon/${token}`);
    }

    async getUserAppointments(customerId, year, page) {
        return http.get(`/appointments`, { params: { customerId: customerId, year: year, page: page } });
    }

    async cancelAppointment(cancellationInfo) {
        return http.put(`/appointments/cancel-appointment`, cancellationInfo);
    }

    /* Membership Plans */
    async getSalonMembershipPlans(salonUuid) {
        return http.get(`/salon/${salonUuid}/membership-plans`);
    }

    async purchaseMembership(salonUuid, data) {
        return http.post(`/salon/${salonUuid}/membership/purchase`, data);
    }

    /*Customer enrolled/subscribed plans */
    async getCustomerMemberships(salonUuid, customerId) {
        return http.get(`/salon/customer/${customerId}/memberships`, { params: { salonUuid: salonUuid } });
    }

    /*Customer notifications*/
    async getUnreadCount(customerId) {
        return http.get(`/notifications/${customerId}/unread-count`);
    }

    // get notifications with pagination
    async getNotifications(customerId, page = 0, size = 10) {
        return await http.get(`/notifications/${customerId}`, {
            params: { page, size },
        });
    }

    // update (mark as read)
    async updateNotification(notificationId) {
        return await http.put(`/notifications/${notificationId}/read`);
    }
    // Advance Payment Summary
    async getAdvanceSummary(data) {
        return await http.post(`/salon/booking/advance-summary`, data);
    }

    async updateUpiPayment(data) {
        return await http.post(`/salon/booking/log-payment/upi`, data);
    }

    // UPI Payment Links
    async getUpiPaymentLink(data) {
        return http.post(`/salon/booking/upi-link`, data);
    }

    //Loyalty Points 
    async getCustomerLoyaltyWallet(salonUuid, customerId) {
        return http.get(`/salon/${salonUuid}/loyalty/${customerId}`);
    }

    //Appointment Details
    async getAppointmentById(apntId) {
        return http.get(`/appointments/appointment-id/${apntId}`);
    }


}

const salonService = new SalonService();
export default salonService;
